"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../../utils");

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

var _excluded = ["id", "children", "href", "onClick", "aria-controls", "onKeyDown", "isSelected", "colorScheme", "shouldWrap"];

var DefaultTabBase = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      children = _ref.children,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? '#' : _ref$href,
      _onClick = _ref.onClick,
      ariaControls = _ref['aria-controls'],
      onKeyDown = _ref.onKeyDown,
      isSelected = _ref.isSelected,
      colorScheme = _ref.colorScheme,
      shouldWrap = _ref.shouldWrap,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var tabIndex = isSelected ? {} : {
    tabIndex: -1
  };

  var handleClick = function handleClick(e, onClick) {
    e.preventDefault();
    onClick();
  };

  return (0, _core.jsx)(_helperComponents.DefaultTabLink, (0, _extends2.default)({}, (0, _utils.pickDataProps)(forwardedProps), tabIndex, {
    "aria-controls": ariaControls,
    "aria-selected": isSelected,
    colorScheme: colorScheme,
    "data-test-selected": isSelected,
    href: href,
    id: id,
    isSelected: isSelected,
    onClick: function onClick(e) {
      return handleClick(e, _onClick);
    },
    onKeyDown: onKeyDown,
    ref: ref,
    role: "tab"
  }), (0, _core.jsx)(_helperComponents.DefaultTabText, {
    fontSize: "T200",
    shouldWrap: shouldWrap
  }, children));
});

var DefaultTab = (0, _utils.withTestAttributes)({
  component: 'StencilTab'
})(DefaultTabBase);
DefaultTab.displayName = 'DefaultTab';
var _default = DefaultTab;
exports.default = _default;